module.exports = __webpack_public_path__ + "img/message9.e9c1a156.png";